import { Reveal, Overline } from "./Reveal";
import { NewsletterForm } from "./NewsletterForm";
import { SITE } from "../config/site";
import { useContent } from "../context/ContentContext";

export const NewsletterSection = () => {
  const heading = useContent("newsletter_heading", "Stay Rooted. Keep Growing.");
  const copy = useContent(
    "newsletter_copy",
    "Thoughts on holistic wellness, conscious living, motherhood, and putting meaningful change into practice. Join the email community for encouragement, insights, and resources. Gentle letters, never noise."
  );
  const headingParts = heading.split(".");

  return (
    <section id="newsletter" data-testid="newsletter-section" className="relative overflow-hidden bg-sage/50 py-24 sm:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-gold/10 blur-3xl"
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline>The Letter</Overline>
            <h2 className="font-serif text-3xl leading-tight text-forest sm:text-4xl lg:text-5xl">
              {headingParts.length > 1 ? (
                <>
                  {headingParts[0]}. <em className="italic text-gold">{headingParts.slice(1).join(".").trim()}</em>
                </>
              ) : (
                heading
              )}
            </h2>
            <p className="mt-6 max-w-xl text-lg font-light leading-relaxed text-charcoal/75">
              {copy}
            </p>
          </Reveal>
          <Reveal delay={0.12} className="mt-9 max-w-xl">
            <NewsletterForm source="newsletter-section" />
          </Reveal>
        </div>
        <Reveal delay={0.15} className="hidden lg:col-span-5 lg:block">
          <div className="relative ml-auto max-w-sm">
            <div
              aria-hidden="true"
              className="absolute -inset-3 translate-x-4 -translate-y-4 rounded-[2.5rem] border border-gold/40"
            />
            <div className="relative overflow-hidden rounded-[2.5rem] shadow-[0_25px_50px_rgba(23,63,53,0.18)]">
              <img
                src={SITE.images.tea}
                alt="A quiet cup of herbal tea in warm natural light"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
